import Col from '../Col2.js';
import TextAreaBase from "./FieldTypeBase/TextAreaBase";
import { forwardRef } from 'react';

const TextAreaBlock =  forwardRef((props, ref) => {
    return (        
        <Col 
           // {...props}
            id={props.objectkey} 
            className={`col-md-${props.field.width} field ${props.field.class || ""}`}>

            <TextAreaBase {...props}  ref={ref} ></TextAreaBase>
                
        </Col>
    );
});
export default TextAreaBlock;